import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RegisterUser } from '@core/models/register-user';
import { APP_CONSTANTS } from 'app/app.config';

@Injectable({
  providedIn: 'any'
})
export class RegisterUserApiService {
  private API_URL = `${APP_CONSTANTS.API_URL}`;

  constructor(private http: HttpClient) {}

  registerUser(registerUser: RegisterUser & { lang?: number }) {
    return this.http.post(`${this.API_URL}register`, registerUser);
  }
}
